import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { copyOf2ng0t8oizk6it as copyOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { jsonTooNested1sdswo7rhfnql as jsonTooNested } from './JsonTreeReader.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { LIST_getInstance2vniy0f7mmb29 as LIST_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var TombstoneClass;
function Tombstone() {
  if (TombstoneClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Tombstone');
    TombstoneClass = $;
  }
  return TombstoneClass;
}
var Tombstone_instance;
function Tombstone_getInstance() {
  return Tombstone_instance;
}
var RedactedKeyClass;
function RedactedKey() {
  if (RedactedKeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'RedactedKey');
    RedactedKeyClass = $;
  }
  return RedactedKeyClass;
}
var RedactedKey_instance;
function RedactedKey_getInstance() {
  return RedactedKey_instance;
}
function resize($this) {
  var newSize = imul($this.x2u_1, 2);
  $this.v2u_1 = copyOf($this.v2u_1, newSize);
  var tmp = 0;
  var tmp_0 = new Int32Array(newSize);
  while (tmp < newSize) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var newIndices = tmp_0;
  // Inline function 'kotlin.collections.copyInto' call
  var this_0 = $this.w2u_1;
  var endIndex = this_0.length;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = this_0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp_1, newIndices, 0, 0, endIndex);
  $this.w2u_1 = newIndices;
}
var JsonPathClass;
function JsonPath() {
  if (JsonPathClass === VOID) {
    class $ {
      constructor(configuration) {
        this.t2u_1 = configuration.o2q_1;
        this.u2u_1 = configuration.n2q_1;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp.v2u_1 = Array(8);
        var tmp_0 = this;
        var tmp_1 = 0;
        var tmp_2 = new Int32Array(8);
        while (tmp_1 < 8) {
          tmp_2[tmp_1] = -1;
          tmp_1 = tmp_1 + 1 | 0;
        }
        tmp_0.w2u_1 = tmp_2;
        this.x2u_1 = -1;
      }
      y2u(sd) {
        this.x2u_1 = this.x2u_1 + 1 | 0;
        var depth = this.x2u_1;
        if (depth >= this.t2u_1) {
          jsonTooNested(this.t2u_1);
        }
        if (depth === this.v2u_1.length) {
          resize(this);
        }
        this.v2u_1[depth] = sd;
      }
      z2u(index) {
        this.w2u_1[this.x2u_1] = index;
      }
      a2v(key) {
        var tmp;
        if (!(this.w2u_1[this.x2u_1] === -2)) {
          this.x2u_1 = this.x2u_1 + 1 | 0;
          tmp = this.x2u_1 === this.v2u_1.length;
        } else {
          tmp = false;
        }
        if (tmp) {
          resize(this);
        }
        this.v2u_1[this.x2u_1] = this.u2u_1 ? key : RedactedKey_instance;
        this.w2u_1[this.x2u_1] = -2;
      }
      b2v() {
        if (this.w2u_1[this.x2u_1] === -2) {
          this.v2u_1[this.x2u_1] = Tombstone_instance;
        }
      }
      c2v() {
        var depth = this.x2u_1;
        if (this.w2u_1[depth] === -2) {
          this.w2u_1[depth] = -1;
          this.x2u_1 = this.x2u_1 - 1 | 0;
        }
        if (!(this.x2u_1 === -1)) {
          this.x2u_1 = this.x2u_1 - 1 | 0;
        }
      }
      d2v() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        this_0.m1('$');
        // Inline function 'kotlin.repeat' call
        var times = this.x2u_1 + 1 | 0;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = this.v2u_1[index];
            if (!(element == null) ? isInterface(element, SerialDescriptor()) : false) {
              if (equals(element.x1p(), LIST_getInstance())) {
                if (!(this.w2u_1[index] === -1)) {
                  this_0.m1('[');
                  this_0.ah(this.w2u_1[index]);
                  this_0.m1(']');
                }
              } else {
                var idx = this.w2u_1[index];
                if (idx >= 0) {
                  this_0.m1('.');
                  this_0.m1(element.b1q(idx));
                }
              }
            } else {
              if (element === RedactedKey_instance) {
                this_0.m1('[<debug info disabled>]');
              } else {
                if (!(element === Tombstone_instance)) {
                  this_0.m1('[');
                  this_0.m1("'");
                  this_0.s1(element);
                  this_0.m1("'");
                  this_0.m1(']');
                }
              }
            }
          }
           while (inductionVariable < times);
        return this_0.toString();
      }
      toString() {
        return this.d2v();
      }
    }
    initMetadataForClass($, 'JsonPath');
    JsonPathClass = $;
  }
  return JsonPathClass;
}
//region block: init
Tombstone_instance = new (Tombstone())();
RedactedKey_instance = new (RedactedKey())();
//endregion
//region block: exports
export {
  JsonPath as JsonPath2hoqh4ysli693,
};
//endregion

//# sourceMappingURL=JsonPath.mjs.map
